import { useState } from "react";
import { SubTabPanel } from "./TabPanel";
import { EditModal } from "./EditModal";

const SIDE_TABS = [
  { id: "event_progression", label: "Event Progression", key: "EC2_EVENT_PROGRESSION_NEW_2" },
  { id: "side_quest", label: "Side Quest", key: "EC2_SIDE_QUEST" },
  { id: "mystic_mine", label: "Mystic Mine", key: "EC2_MYSTIC_MINE" },
] as const;

type SideTabId = (typeof SIDE_TABS)[number]["id"];

interface SideContentsTabProps {
  data: Record<string, string>;
  onSaveKey: (key: string, value: string) => void;
}

function PrettyView({ value }: { value: string }) {
  let parsed: unknown;
  try { parsed = JSON.parse(value); } catch { parsed = value; }

  if (parsed === null || parsed === "null") {
    return <div className="text-sm text-muted-foreground">—</div>;
  }

  if (typeof parsed === "object") {
    return (
      <pre className="text-xs bg-muted/50 p-3 rounded overflow-auto max-h-80 whitespace-pre-wrap">
        {JSON.stringify(parsed, null, 2)}
      </pre>
    );
  }

  return <div className="text-sm text-muted-foreground">{String(parsed)}</div>;
}

export function SideContentsTab({ data, onSaveKey }: SideContentsTabProps) {
  const [activeSub, setActiveSub] = useState<SideTabId>("event_progression");
  const [editModal, setEditModal] = useState(false);

  const activeConfig = SIDE_TABS.find(t => t.id === activeSub)!;
  const rawValue = data[activeConfig.key] ?? "null";

  return (
    <div className="space-y-3">
      <SubTabPanel
        tabs={SIDE_TABS.map(t => ({ id: t.id, label: t.label }))}
        activeTab={activeSub}
        onTabChange={(id) => setActiveSub(id as SideTabId)}
      />

      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground font-mono">{activeConfig.key}</span>
        <button
          onClick={() => setEditModal(true)}
          className="text-xs text-primary hover:underline"
        >
          Edit JSON
        </button>
      </div>

      <PrettyView value={rawValue} />

      {editModal && (
        <EditModal
          keyName={activeConfig.key}
          initialValue={rawValue}
          onSave={(val) => { onSaveKey(activeConfig.key, val); setEditModal(false); }}
          onClose={() => setEditModal(false)}
        />
      )}
    </div>
  );
}
